export default __webpack_public_path__ + "static/media/wave-grap.dd617dec.svg";